import React, { useState, useEffect } from 'react';
import './styles/globals.css';

import Navbar           from './components/Navbar';
import Hero             from './components/Hero';
import WhatWeDo         from './components/WhatWeDo';
import About            from './components/About';
import RecentEvents     from './components/RecentEvents';
import Programs         from './components/Programs';
import EBoard           from './components/EBoard';
import MemberSpotlights from './components/MemberSpotlights';
import CalendarSection  from './components/CalendarSection';
import Newsletter       from './components/Newsletter';
import MembersPortal    from './components/MembersPortal';
import Donate           from './components/Donate';
import Sponsors         from './components/Sponsors';
import FAQSection       from './components/FAQ';
import { ContactSection, Footer } from './components/ContactAndFooter';
import { ADMIN_EMAILS, SHOW_PORTAL, SHOW_MEMBER_SPOTLIGHTS } from './data/config';

// ── SIMULATED AUTH ────────────────────────────────────────────
// REPLACE with real MSAL when deploying. See config.js → AUTH
function useSimulatedAuth() {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('shpe_user')); } catch { return null; }
  });
  const login = () => {
    const email = window.prompt('SHPE@VT Members Portal\n\nEnter your @vt.edu email to simulate login:\n(Production: redirects to Microsoft SSO)');
    if (!email) return;
    if (!email.endsWith('@vt.edu')) { alert('Access restricted to @vt.edu accounts only.'); return; }
    const userData = { email, name: email.split('@')[0].replace(/\./g, ' ') };
    setUser(userData);
    sessionStorage.setItem('shpe_user', JSON.stringify(userData));
  };
  const logout = () => { setUser(null); sessionStorage.removeItem('shpe_user'); };
  return { user, login, logout };
}

export default function App() {
  const { user, login, logout } = useSimulatedAuth();
  const [showScrollTop, setShowScrollTop] = useState(false);
  const isAdmin = user && ADMIN_EMAILS.includes(user.email);

  useEffect(() => {
    const onScroll = () => setShowScrollTop(window.scrollY > 400);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div style={{ minHeight: '100vh' }}>
      <Navbar currentUser={user} onLogin={login} onLogout={logout} />
      <Hero />
      <WhatWeDo />
      <About />
      <RecentEvents />
      <Programs />
      <EBoard />
      {SHOW_MEMBER_SPOTLIGHTS && <MemberSpotlights />}
      <CalendarSection currentUser={user} isAdmin={isAdmin} />
      <Newsletter />
      {SHOW_PORTAL && (
        <MembersPortal currentUser={user} isAdmin={isAdmin} onLogin={login} />
      )}
      <Donate />
      <Sponsors />
      <FAQSection />
      <ContactSection />
      <Footer />
      {showScrollTop && (
        <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          style={{
            position: 'fixed', bottom: 28, right: 28, zIndex: 999,
            width: 48, height: 48, borderRadius: '50%',
            background: '#861F41', color: 'white', border: 'none',
            fontSize: 20, cursor: 'pointer',
            boxShadow: '0 4px 16px rgba(134,31,65,0.4)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            transition: 'transform 0.2s ease',
          }}
          onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-3px)'}
          onMouseLeave={e => e.currentTarget.style.transform = 'none'}
          aria-label="Scroll to top">↑</button>
      )}
    </div>
  );
}